import Player from '@vimeo/player';
import elementIsVisible from '../../core/INF-elementIsVisible';
import { resizeVideo } from './resizeVideos';
import initControls from './initControls';

const vimeo_players = {};
window.vimeo_players = vimeo_players;
const vimeo_timestamps = {};

const vimeoPlayerInit = (container) => {
  const playerElement = container.querySelector('[data-video-player]');
  const player_id = playerElement.getAttribute('id');

  vimeo_players[player_id] = new Player(player_id, {
    id: container.dataset.videoId,
    autopause: false,
    byline: false,
    loop: true,
    muted: true,
    playsinline: true,
    portrait: false,
    title: false,
  });

  vimeo_players[player_id].on('loaded', () => {
    resizeVideo(container);

    if (vimeo_timestamps[player_id]) {
      vimeo_players[player_id].setCurrentTime(vimeo_timestamps[player_id]);
    }

    // We don't want to autoplay every single video...just the one that's visible
    if (elementIsVisible(container)) {
      vimeo_players[player_id].play();
    }
  });

  vimeo_players[player_id].on('play', () => {
    if (container.classList.contains('BackgroundVideo--init')) {
      return false;
    }

    // Video is playing (not buffering or just "ready") and we haven't fully initialized it yet
    container.classList.add('BackgroundVideo--init');
    return initControls(container, vimeo_players[player_id], 'vimeo');
  });

  // Because vimeo uses a promise for getCurrentTime, we can't do it in the theme editor on unload.

  // There isn't enough time for the promise to resolve, so we always end up starting the video over.

  // So if we're in an iframe (theme editor) track the time as the video plays for use on section redraw.

  if (window.parent !== window) {
    vimeo_players[player_id].on('timeupdate', (data) => {
      vimeo_timestamps[player_id] = data.seconds;
    });
  }
};

export { vimeo_players, vimeoPlayerInit };
